// Externe Bibliotheken
import React, { Component } from 'react';
import { Link } from 'react-router';
import _ from 'lodash';
import axios from 'axios';
import { LazyLoadImage } from 'react-lazy-load-image-component';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertDate, convertPrice, createPaxAges } from '@/_helper/mapper';
import { getSearchParams } from '@/_helper/searchParamsHelper';
import { checkAccess } from '../_helper/checkAccess';
import { withRouter } from '@/_helper/withRouter';
import { buildPostRequest } from '@/_helper/apiHelper';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import HeroTeaser from '@/comp/heroTeaser';
import TravelFactsFull from '../_comp/travelFactsFull';
import Button from '@/comp/button/button.tsx';
import { Icon } from '@/comp/icon/icon.tsx';

// Styles
import './excursion-rates.scss';

let filterArray = {};

class ExcursionRates extends Component {
    constructor(props) {
        super(props);

        this.state = {
            excursionCode: props.params.id !== null ? props.params.id : null,
            searchParams: getSearchParams(),
            showFilter: false,
            filter: {
                sort: {
                    state: 'close',
                    current: 'startDate_asc',
                    list: {
                        price_asc: {
                            title: 'Preis: niedrigster zuerst',
                        },
                        price_desc: {
                            title: 'Preis: höchster zuerst',
                        },
                        startDate_asc: {
                            title: 'Datum: aufsteigend',
                        },
                        startDate_desc: {
                            title: 'Datum: absteigend',
                        },
                    },
                },
                pickUpTimeRangeFilter: {
                    a: 0,
                    b: 24,
                },
                durationFilter: {
                    a: 0,
                    b: 10,
                },
            },
            rates: [],
            oRates: [],
        };

        this.filterBar = this.filterBar.bind(this);
        this.rates = this.rates.bind(this);
    }

    componentDidMount() {
        document.title = 'Ausflüge' + window.$documentTitle;

        document.querySelector('html').classList.add('redesign');

        // not allowed
        checkAccess('allowExtraServicesExcursion');
        if (this.state.excursionCode === null) {
            window.location.href = '#/';
        }

        this.getExcursion();

        // remove
        let units = [];
        Object.keys(this.state.oRates).forEach((value) => {
            units.push(this.state.oRates[value].unitDescription);
        });
        units = _.uniq(units);

        this.setState({
            units: units,
        });
    }

    getExcursion() {
        const { excursionCode } = this.state;

        let offers = storage.get('excursionOffers');

        if (offers !== null) {
            let ex = _.filter(offers.data?.excursionOffers, function (o) {
                return o.supplierOfferId === excursionCode;
            });

            if (ex[0] === undefined) {
                window.location.href = '#/ausfluege';
            }

            this.setState({
                excursion: ex[0],
            });

            // set document title
            document.title = ex[0]?.title + ' | Raten' + window.$documentTitle;

            // get rates
            this.searchRates(ex[0].supplierOfferId);

            return false;
        } else {
            window.location.href = '#/ausfluege';
        }
    }

    hasPriceChange(value) {
        let { excursion, oRates } = this.state;

        let originalPrice = excursion?.price?.overallGrossPrice;
        let offerPrice = value?.price?.overallGrossPrice;

        let getAllRatesPrices = oRates.map(function (o) {
            return o?.price?.overallGrossPrice;
        });

        let lowPricedOffer = _.min(getAllRatesPrices.sort());

        if (originalPrice !== undefined && offerPrice !== undefined) {
            return offerPrice === lowPricedOffer && lowPricedOffer > originalPrice;
        }
        return false;
    }

    searchRates(k) {
        const { searchParams } = this.state;
        if (searchParams === undefined || searchParams.p === undefined) {
            window.location.href = '#/ausfluege/details/' + k;
            return false;
        }

        let bookingData = storage.get('bookingData');
        let bookingDataSearchParams = undefined;
        if (bookingData !== null) {
            bookingDataSearchParams = bookingData.data.searchParams;
        }

        // create pax ages
        let paxAgesString = '';
        searchParams.p.forEach((value) => {
            let getBirthDate = bookingData.bookingParams?.travellers[value].dateOfBirth;

            if (getBirthDate !== undefined) {
                let birthDate = new Date(getBirthDate);
                let year = new Date(Date.now() - birthDate.getTime()).getUTCFullYear();
                let age = Math.abs(year - 1970);

                if (age >= 18) {
                    paxAgesString += 'a:18;';
                }

                if (age < 18) {
                    paxAgesString += 'c:' + age + ';';
                }
            }
        });

        const sendData = {
            requestType: 'searchOfferExtra',
            clientId: 'customerarea',
            travelType: 'excursion',
            hotelCode: bookingDataSearchParams.hotelCode,
            regionCode: bookingDataSearchParams.destination,
            arrivalAirportCode: bookingDataSearchParams.retAirport,
            travelStart: convertDate(bookingDataSearchParams.depDate),
            travelEnd: convertDate(bookingDataSearchParams.retDate),
            paxAges: createPaxAges(paxAgesString.slice(0, -1)),
            excursionId: k,
        };

        axios(buildPostRequest(window.$requestUrl, '/searchExtra', JSON.stringify(sendData)))
            .then((response) => response)
            .then((data) => {
                let r = data.data.data;

                if (r !== undefined && r.statusCode === 200) {
                    let rates = [];
                    let units = [];

                    Object.keys(r.excursionOffers).forEach((value) => {
                        // set filter parameter : show
                        let v = r.excursionOffers[value];
                        v['show'] = true;
                        v['validate'] = false;
                        v['valid'] = false;
                        rates.push(v);

                        if (v.unitDescription !== null && v.unitDescription.length > 0) {
                            units.push(v.unitDescription);
                        }
                    });

                    units = _.uniq(units);

                    // sort rates by start date , price
                    rates = _.orderBy(
                        rates,
                        [
                            'startDate',
                            function (item) {
                                if (item.price.pricePerPerson !== undefined) {
                                    return item.price.pricePerPerson;
                                }
                            },
                        ],
                        ['asc']
                    );

                    this.setState({
                        rates: rates,
                        oRates: rates,
                        units: units,
                        hasResult: rates.length > 0,
                        processToken: r.processToken,
                    });
                } else {
                    this.setState({
                        hasResult: false,
                        error: true,
                        isLoading: false,
                    });
                }
            })
            .catch((error) => this.setState({ error }));
    }

    filterBar() {
        let { excursion, rates } = this.state;

        if (excursion === undefined) {
            return false;
        }

        let $this = this;

        function filterLogic(filter, event, v, index) {
            const target = event.target;
            let value = target.value;

            if (filterArray[filter] === undefined) {
                filterArray[filter] = [];
            }

            value = target.checked !== true ? false : true;

            // date
            function dateValue(value, hasDate) {
                let splitDate = value.split('T');
                let dateValue;

                if (!hasDate) {
                    dateValue = new Date('1999-01-01 00:00:00Z');
                    splitDate = splitDate[0].split(':');
                    dateValue.setHours(splitDate[0]);
                    dateValue.setMinutes(splitDate[1]);
                } else {
                    dateValue = new Date(value);
                    dateValue.setDate(1);
                    dateValue.setFullYear(1999);
                    dateValue.setMonth(0);
                }
                return dateValue;
            }

            switch (filter) {
                case 'filterUnits':
                    let chip = document.querySelector('.units .chip[unit^="' + index + '"]');

                    if (value) {
                        filterArray[filter].push(v);

                        // sync
                        if (document.querySelector('.units .chip') !== null) {
                            chip.classList.add('selected');
                        }
                    } else {
                        filterArray[filter] = filterArray[filter].filter(function (value) {
                            return value !== v;
                        });

                        // sync
                        if (document.querySelector('.units .chip') !== null) {
                            chip.classList.remove('selected');
                        }
                    }

                    if (filterArray[filter].length === 0) {
                        Object.keys(rates).forEach((value) => {
                            rates[value].show = true;
                        });
                    } else {
                        Object.keys(rates).forEach((value) => {
                            let rate = rates[value];

                            if (filterArray[filter].indexOf(rate.unitDescription) >= 0) {
                                rates[value].show = true;
                                rates[value]['filterUnits'] = true;
                            } else {
                                rates[value].show = false;
                                delete rates[value]['filterUnits'];
                            }
                        });
                    }
                    break;
                case 'filterWeekday':
                    if (value) {
                        filterArray[filter].push(v);
                    } else {
                        filterArray[filter] = filterArray[filter].filter(function (value) {
                            return value !== v;
                        });
                    }

                    if (filterArray[filter].length === 0) {
                        Object.keys(rates).forEach((value) => {
                            rates[value].show = true;
                        });
                    } else {
                        Object.keys(rates).forEach((value) => {
                            let rate = rates[value];
                            let weekday = new Date(rate.startDate.split('T')[0]).toLocaleDateString('de-DE', {
                                weekday: 'long',
                            });

                            if (filterArray[filter].indexOf(weekday) >= 0) {
                                rates[value].show = true;
                                rates[value]['filterWeekday'] = true;
                            } else {
                                rates[value].show = false;
                                delete rates[value]['filterWeekday'];
                            }
                        });
                    }
                    break;
                case 'filterPickupDropOffIndicator':
                    if (value) {
                        filterArray[filter].push(v);
                    } else {
                        filterArray[filter] = [];
                    }

                    if (filterArray[filter].length === 0) {
                        Object.keys(rates).forEach((value) => {
                            rates[value].show = true;
                        });
                    } else {
                        Object.keys(rates).forEach((value) => {
                            rates[value].show = false;
                            delete rates[value]['filterPickupDropOffIndicator'];
                        });
                        _.filter(rates, function (o, index) {
                            if (o.pickupDropOffIndicator === 'true') {
                                rates[index].show = true;
                                rates[index]['filterPickupDropOffIndicator'] = true;
                                return true;
                            }
                            return false;
                        });
                    }
                    break;
                case 'filterPickUp': {
                    if (!filterArray[filter][0]) {
                        filterArray[filter][0] = {};
                    }

                    if (event.target.name === 'start') {
                        filterArray[filter][0].start = dateValue(v, false).getTime();
                    } else {
                        filterArray[filter][0].end = dateValue(v, false).getTime();
                    }

                    let ind = rates;
                    let initStart = dateValue('00:00', false).getTime();
                    let initEnd = dateValue('24:00', false).getTime();

                    if (
                        (filterArray[filter][0].start === undefined || filterArray[filter][0].start === initStart) &&
                        (filterArray[filter][0].end === undefined || filterArray[filter][0].end === initEnd)
                    ) {
                        delete filterArray[filter];
                    } else {
                        ind = _.filter(rates, function (o) {
                            let oDate;
                            if (o.transferTime !== null) {
                                oDate = dateValue(o.transferTime, false).getTime();
                                return (
                                    o.pickupDropOffIndicator === 'true' &&
                                    (filterArray[filter][0].start !== undefined
                                        ? oDate >= filterArray[filter][0].start
                                        : true) &&
                                    (filterArray[filter][0].end !== undefined
                                        ? oDate <= filterArray[filter][0].end
                                        : true)
                                );
                            }
                            return false;
                        });
                    }

                    Object.keys(rates).forEach((value) => {
                        delete rates[value]['filterPickUp'];
                    });
                    Object.keys(ind).forEach((value) => {
                        ind[value]['filterPickUp'] = true;
                    });
                    break;
                }
                case 'filterDuration': {
                    if (!filterArray[filter][0]) {
                        filterArray[filter][0] = {};
                    }

                    if (event.target.name === 'start') {
                        filterArray[filter][0].start = v;
                    } else {
                        filterArray[filter][0].end = v;
                    }

                    if (
                        (filterArray[filter][0].start === undefined || filterArray[filter][0].start === '0') &&
                        (filterArray[filter][0].end === undefined || filterArray[filter][0].end === '10')
                    ) {
                        delete filterArray[filter];
                    } else {
                        let ind = _.filter(rates, function (o) {
                            let oDuration = o.duration.slice(o.duration.indexOf('PT') + 2, o.duration.indexOf('H'));

                            return (
                                (filterArray[filter][0].start
                                    ? parseInt(oDuration) >= parseInt(filterArray[filter][0].start)
                                    : true) &&
                                (filterArray[filter][0].end
                                    ? parseInt(oDuration) <= parseInt(filterArray[filter][0].end)
                                    : true)
                            );
                        });

                        Object.keys(rates).forEach((value) => {
                            delete rates[value]['filterDuration'];
                        });
                        Object.keys(ind).forEach((value) => {
                            rates[value]['filterDuration'] = true;
                        });
                    }

                    break;
                }
                default:
            }

            Object.keys(rates).forEach((value) => {
                rates[value].show = true;
            });

            Object.keys(filterArray).forEach((item) => {
                if (filterArray[item].length !== 0) {
                    rates.forEach((value) => {
                        if (!value[item]) {
                            value.show = false;
                            return false;
                        }
                    });
                }
            });

            $this.setState({
                rates: rates,
            });
        }

        const filterUnits = () => {
            let { units } = $this.state;

            if (units.length < 2) {
                return false;
            }

            return (
                <div className="filter units highlighted">
                    <h4 className="subheadline">Ausflugsvariante</h4>
                    <div className="cnt">
                        {units.map((value, index) => {
                            return (
                                <label key={index} unit={index}>
                                    <input
                                        type="checkbox"
                                        onClick={(e) => filterLogic('filterUnits', e, value, index)}
                                    />
                                    <span className="checkbox-trigger"></span>
                                    <span>{value}</span>
                                </label>
                            );
                        })}
                    </div>
                </div>
            );
        };

        const filterWeekday = () => {
            let days = [],
                refDays = [];
            Object.keys($this.state.oRates).forEach((value, index) => {
                let rate = $this.state.oRates[value];
                let v = new Date(rate.startDate.split('T')[0]).toLocaleDateString('de-DE', { weekday: 'long' });
                if (refDays.indexOf(v) < 0) {
                    refDays.push(v);
                    days.push(
                        <label key={index}>
                            <input type="checkbox" onClick={(e) => filterLogic('filterWeekday', e, v)} />
                            <span className="checkbox-trigger"></span>
                            <span>{v}</span>
                        </label>
                    );
                }
            });

            if (days.length === 0) {
                return false;
            }

            return (
                <div className="filter ">
                    <h4 className="subheadline">Wochentag</h4>
                    <div className="cnt">{days}</div>
                </div>
            );
        };

        const filterDuration = () => {
            const handleRangeInput = (e) => {
                let elem = e.target;
                let root = document.querySelector('.duration-slider-wrapper.filter');
                e.persist();
                this.setState((state) => {
                    if (elem.id === 'a') {
                        state.filter.durationFilter.a = elem.value;
                        root.style.setProperty('--RangeFilterA', elem.value);
                    } else {
                        state.filter.durationFilter.b = elem.value;
                        root.style.setProperty('--RangeFilterB', elem.value);
                    }
                    return state;
                });
                root.style.setProperty('--RangeFilterDiff', 10);
                root.style.setProperty('--RangeFilterB', this.state.filter.durationFilter.b);
                filterLogic('filterDuration', e, elem.value);
            };

            return (
                <div className="duration-slider-wrapper filter" role="group" aria-labelledby="multi-lbl">
                    <h4 className="subheadline">Dauer des Ausflugs</h4>
                    <label className="sr-only" htmlFor="a">
                        {this.state.filter.durationFilter.a} bis {this.state.filter.durationFilter.b} Stunden
                    </label>
                    <input
                        className="firstRangeSlider"
                        name="start"
                        step="1"
                        id="a"
                        type="range"
                        min="0"
                        value={this.state.filter.durationFilter.a}
                        max="10"
                        onChange={(e) => {
                            handleRangeInput(e);
                        }}
                    />
                    <input
                        id="b"
                        type="range"
                        name="end"
                        step="1"
                        min="0"
                        value={this.state.filter.durationFilter.b}
                        max="10"
                        onChange={(e) => {
                            handleRangeInput(e);
                        }}
                    />
                </div>
            );
        };

        const filterPickUp = () => {
            const h_mm = (time) => {
                let minutes = Math.round(60 * Math.abs(time));
                return (
                    (time < 0 ? '-' : '') +
                    parseInt(minutes / 60) +
                    (100 + (minutes % 60)).toString().replace(/^1/, ':')
                );
            };

            const handleRangeInput = (e) => {
                let elem = e.target;
                let root = document.querySelector('.pickup-slider-wrapper.filter');
                e.persist();
                this.setState((state) => {
                    if (elem.id === 'a') {
                        state.filter.pickUpTimeRangeFilter.a = elem.value;
                        root.style.setProperty('--RangeFilterA', elem.value);
                    } else {
                        state.filter.pickUpTimeRangeFilter.b = elem.value;
                        root.style.setProperty('--RangeFilterB', elem.value);
                    }
                    return state;
                });
                filterLogic('filterPickUp', e, h_mm(elem.value));
            };

            return (
                <div className="pickup-slider-wrapper filter" role="group" aria-labelledby="multi-lbl">
                    <h4 className="subheadline">Uhrzeit - Pickup am Hotel</h4>
                    <label className="sr-only" htmlFor="a">
                        {h_mm(this.state.filter.pickUpTimeRangeFilter.a)} bis{' '}
                        {h_mm(this.state.filter.pickUpTimeRangeFilter.b)} Uhr
                    </label>
                    <input
                        className="firstRangeSlider"
                        name="start"
                        step="0.25"
                        id="a"
                        type="range"
                        min="0"
                        value={this.state.filter.pickUpTimeRangeFilter.a}
                        max="24"
                        onChange={(e) => {
                            handleRangeInput(e);
                        }}
                    />
                    <input
                        id="b"
                        type="range"
                        name="end"
                        step="0.25"
                        min="0"
                        value={this.state.filter.pickUpTimeRangeFilter.b}
                        max="24"
                        onChange={(e) => {
                            handleRangeInput(e);
                        }}
                    />
                </div>
            );
        };

        const filterPickupDropOffIndicator = () => {
            let ind = _.filter(this.state.oRates, function (o) {
                return o.pickupDropOffIndicator === 'true';
            });
            if (ind.length === 0) {
                return false;
            }

            return (
                <div className="filter ">
                    <h4 className="subheadline">Transport zum Ausflug</h4>
                    <div className="cnt">
                        <label>
                            <input
                                type="checkbox"
                                onClick={(e) =>
                                    filterLogic(
                                        'filterPickupDropOffIndicator',
                                        e,
                                        e.target.checked !== true ? false : true
                                    )
                                }
                            />
                            <span className="checkbox-trigger"></span>
                            <span>nur inkl. Transport zum Ausflug anzeigen</span>
                        </label>
                    </div>
                </div>
            );
        };

        if (rates.length === 0) {
            return false;
        }

        return (
            <div
                className={`filter-bar ${this.state.showFilter ? 'active' : ''}  ${
                    _.filter(rates, function (o) {
                        return o.validate;
                    }).length > 0
                        ? 'validate'
                        : ' '
                }`}>
                <span className="close" onClick={() => this.setState({ showFilter: !this.state.showFilter })}>
                    zurück
                </span>

                <button
                    className="button filter-button flex-between"
                    onClick={() =>
                        window.innerWidth <= 900 ? this.setState({ showFilter: !this.state.showFilter }) : ''
                    }>
                    <div title="jetzt filtern">Ergebnisse filtern</div>
                </button>
                <div className="main-content">
                    {filterUnits()}

                    {filterWeekday()}

                    {filterPickUp()}

                    {filterDuration()}

                    {filterPickupDropOffIndicator()}
                </div>
            </div>
        );
    }

    rates() {
        let { excursion, rates, searchParams, excursionCode, filter } = this.state;

        let $this = this;

        function unitInfo() {
            if ($this.state.units.length < 2) {
                return false;
            }

            return (
                <div className="unit-infos">
                    <div className="head">
                        <div className="icon">
                            <span>!</span>
                        </div>
                        <div>
                            Für den Ausflug "{excursion.title}" gibt es mehrere Varianten.
                            <br />
                            Bitte beachten Sie dies bei Ihrer Auswahl.
                        </div>
                    </div>
                </div>
            );
        }

        function filterUnits() {
            let { units } = $this.state;

            if (units.length < 2) {
                return false;
            }

            let filterList = (e) => {
                // select : chip
                if (e.target.classList.contains('selected')) {
                    e.target.classList.remove('selected');

                    // sync
                    if (
                        document.querySelector('.filter.units label[unit^="' + e.target.getAttribute('unit') + '"]') !==
                        null
                    ) {
                        document
                            .querySelector('.filter.units label[unit^="' + e.target.getAttribute('unit') + '"]')
                            .click();
                    }
                } else {
                    e.target.classList.add('selected');

                    // sync
                    if (
                        document.querySelector(
                            '.filter.units label[unit^="' + e.target.getAttribute('unit') + '"] input'
                        ) !== null
                    ) {
                        document
                            .querySelector('.filter.units label[unit^="' + e.target.getAttribute('unit') + '"]')
                            .click();
                    }
                }
            };

            return (
                <div className={`units`}>
                    {units.map((value, index) => {
                        return (
                            <div className="chip" unit={index} key={index} onClick={(e) => filterList(e)}>
                                {value}
                            </div>
                        );
                    })}
                </div>
            );
        }

        function sortTrigger() {
            if (rates.length === 0) {
                return false;
            }

            const sortList = (e, sort) => {
                let sortList = rates;

                switch (sort) {
                    case (sort = 'price_asc'):
                        sortList = _.orderBy(
                            rates,
                            [
                                function (item) {
                                    return item.price.pricePerPerson;
                                },
                            ],
                            ['asc']
                        );
                        break;
                    case (sort = 'price_desc'):
                        sortList = _.orderBy(
                            rates,
                            [
                                function (item) {
                                    return item.price.pricePerPerson;
                                },
                            ],
                            ['desc']
                        );
                        break;
                    case (sort = 'startDate_asc'):
                        sortList = _.orderBy(
                            rates,
                            [
                                'startDate',
                                function (item) {
                                    return item.price.pricePerPerson;
                                },
                            ],
                            ['asc']
                        );
                        break;
                    case (sort = 'startDate_desc'):
                        sortList = _.orderBy(
                            rates,
                            [
                                'startDate',
                                function (item) {
                                    return item.price.pricePerPerson;
                                },
                            ],
                            ['desc']
                        );
                        break;
                    default:
                }

                let filterArr = filter;
                filterArr.sort.state = 'close';
                filterArr.sort.current = sort;

                $this.setState({
                    rates: sortList,
                    filter: filterArr,
                });
            };

            return (
                <div className={`sort-trigger ${filter.sort.state}`}>
                    <div
                        className="current"
                        onClick={() => {
                            let filterArr = { ...filter };
                            switch (filterArr.sort.state) {
                                case 'open':
                                    filterArr.sort.state = 'close';
                                    break;
                                case 'close':
                                    filterArr.sort.state = 'open';
                                    break;
                                default:
                            }
                            $this.setState({ filter: filterArr });
                        }}>
                        <Icon name="compareArrows" />
                        <span>{filter.sort.list[filter.sort.current].title}</span>
                    </div>
                    <div className="options">
                        {Object.keys(filter.sort.list).map(
                            (value, index) =>
                                filter.sort.current !== value && (
                                    <div key={index} onClick={(e) => sortList(e, value)}>
                                        {filter.sort.list[value].title}
                                    </div>
                                )
                        )}
                    </div>
                </div>
            );
        }

        function card(value, index) {
            // date
            const dateValue = () => {
                let dateValue = value.startDate.split('T');

                // full date
                let date = new Date(dateValue[0]).toLocaleDateString('de-DE', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                });

                // weekday
                let weekday = new Date(dateValue[0]).toLocaleDateString('de-DE', { weekday: 'long' });

                // time
                let time = '';
                if (dateValue[1] !== undefined) {
                    time = dateValue[1].slice(0, -3);
                }

                return {
                    fullDate: date !== undefined ? date : '',
                    weekday: weekday !== undefined ? weekday : '',
                    time: time !== undefined ? time : '',
                };
            };

            const parseTime = (value) => {
                let timeValue = '';
                if (value !== undefined && value !== null) {
                    timeValue = value.slice(0, -3);
                }
                return timeValue;
            };

            const toggleInfoLayer = (elem) => {
                elem.classList.toggle('active');
            };

            // duration
            const durationValue = () => {
                let duration = value.duration;
                if (duration === '0') {
                    duration = '';
                } else {
                    duration = duration.replaceAll('PT', '');

                    if (parseInt(duration.substring(0, duration.indexOf('H'))) === 1) {
                        duration = duration.replaceAll('H', ' Stunde ');
                    } else {
                        duration = duration.replaceAll('H', ' Stunden ');
                    }

                    if (parseInt(duration.substring(0, duration.indexOf('M'))) === 1) {
                        duration = duration.replaceAll('M', ' Minute ');
                    } else {
                        duration = duration.replaceAll('M', ' Minuten ');
                    }
                }

                return (
                    <>
                        <b>{duration}</b>
                        <span className="text-normal">Dauer </span>
                        {value?.transferIncluded && <span className="text-normal">(ohne Transferzeit)</span>}
                    </>
                );
            };

            // paxe
            const paxe = () => {
                let bookingData = storage.get('bookingData');

                if (bookingData === undefined || bookingData === null) {
                    return false;
                }

                let a = 0,
                    c = 0;

                searchParams.p.forEach((value) => {
                    if (bookingData.data.frontendParams?.travellers !== null) {
                        let getBirthDate = bookingData.bookingParams?.travellers[value].dateOfBirth;
                        if (getBirthDate !== undefined) {
                            let birthDate = new Date(getBirthDate);

                            let year = new Date(Date.now() - birthDate.getTime()).getUTCFullYear();
                            let age = Math.abs(year - 1970);

                            if (age >= 18) {
                                a++;
                            }

                            if (age < 18) {
                                c++;
                            }
                        }
                    }
                });

                if (a + c === 0) {
                    return false;
                }

                return (
                    <div className="e persons flex flex-middle">
                        <Icon name="personFilled" size={30} ariaHidden />
                        <div className="cnt">
                            {a > 0 && (
                                <div>
                                    {' '}
                                    {a} {a > 1 ? 'Erwachsene' : 'Erwachsener'}
                                </div>
                            )}

                            {c > 0 && (
                                <div>
                                    {' '}
                                    {c} {c > 1 ? 'Kinder' : 'Kind'}
                                </div>
                            )}
                        </div>
                    </div>
                );
            };

            return (
                <>
                    <div className="head">
                        <div className="heading">{dateValue().fullDate + ' - ' + dateValue().weekday}</div>
                    </div>
                    <div className="content">
                        {value.unitDescription !== null && value.unitDescription.length > 0 && (
                            <div className="unit">{value.unitDescription}</div>
                        )}

                        <div className="information">
                            <div className="line">
                                {!value.transferIncluded ? (
                                    <div className="e ticket flex flex-middle">
                                        <Icon name="confirmationNumber" ariaHidden />
                                        <div className="cnt">
                                            <div>
                                                <b>Ticket / Eintrittskarte</b>
                                                {(!value.startTime || !value.duration || value.duration === '0') && (
                                                    <small>gültig innerhalb der Öffnungszeiten </small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    (value.transferTime || value.startTime || value.duration !== '0') && (
                                        <div className="e duration flex flex-middle">
                                            <Icon name="schedule" size={30} ariaHidden />
                                            <div className="cnt">
                                                {value.transferTime && (
                                                    <div className="transfer-time">
                                                        <b>{parseTime(value.transferTime)} Uhr</b> Pickup am Hotel
                                                        <span className="info-icon">
                                                            <i
                                                                role="contentinfo"
                                                                aria-label="info"
                                                                onClick={(e) => {
                                                                    toggleInfoLayer(e.target.nextElementSibling);
                                                                }}
                                                                onMouseOver={(e) => {
                                                                    toggleInfoLayer(e.target.nextElementSibling);
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    toggleInfoLayer(e.target.nextElementSibling);
                                                                }}>
                                                                <Icon name="info" ariaHidden />
                                                            </i>

                                                            <div
                                                                className="info-layer"
                                                                onMouseLeave={(e) => {
                                                                    toggleInfoLayer(e.target);
                                                                }}>
                                                                <div className="info-layer-header">
                                                                    <b>Pickup am Hotel:</b>
                                                                    <i
                                                                        onClick={(e) => {
                                                                            toggleInfoLayer(
                                                                                e.target.parentNode.parentNode
                                                                            );
                                                                        }}>
                                                                        <Icon name="close" ariaHidden />
                                                                    </i>
                                                                </div>
                                                                <div className="info-layer-content">
                                                                    Den exakten Treffpunkt für den Pickup finden Sie im
                                                                    Voucher des Ausflugs, der in Ihren Reiseunterlagen
                                                                    enthalten ist.
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </div>
                                                )}
                                                {value.startTime && (
                                                    <div>
                                                        <b>{parseTime(value.startTime)} Uhr</b> Beginn
                                                    </div>
                                                )}
                                                {value.duration !== '0' && <div>{durationValue()}</div>}
                                            </div>
                                        </div>
                                    )
                                )}

                                {paxe()}
                            </div>

                            {value.transferIncluded === false && (value.startTime || value.duration !== '0') && (
                                <div className="line">
                                    <div className="e start flex flex-middle">
                                        <Icon name="schedule" size={30} ariaHidden />
                                        <div className="cnt">
                                            {value.startTime && (
                                                <div>
                                                    <b>{parseTime(value.startTime)} Uhr</b> Beginn
                                                </div>
                                            )}
                                            {value.duration !== '0' && <div>{durationValue()}</div>}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="line">
                                <div
                                    className={`e transport flex ${
                                        value.pickupDropOffIndicator === 'true' ? 'yes' : 'no'
                                    }`}>
                                    <Icon name="directionsBus" ariaHidden />
                                    <div className="cnt">
                                        <div>
                                            <b>{value.transferIncluded === true ? 'inkl.' : 'ohne'} Transport</b>

                                            {value.transferIncluded === true && (
                                                <small>{value.transferDescription}</small>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {value.mealDescription !== null && value.mealDescription.length > 0 && (
                                    <div className={`e meal flex flex-middle`}>
                                        <Icon name="restaurant" ariaHidden />
                                        <div className="cnt">
                                            <div>
                                                <b>inkl. Verpflegung</b>

                                                <small>{value.mealDescription}</small>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="call-action">
                            <div className="total-price">
                                <div className="small-print">Gesamtpreis</div>
                                {value.price.maxGrossPrice >= 0 ? '+' : '-'}{' '}
                                {convertPrice(value.price.overallGrossPrice, 0, 0)}
                                {$this.hasPriceChange(value) && (
                                    <div className="small-print price-change">
                                        Bitte beachten Sie die kurzfristige Preiserhöhung.
                                    </div>
                                )}
                            </div>

                            <Button
                                validated={value.validate}
                                valid={!value.notAvailable}
                                handleClick={() => {
                                    $this.vacancy(value.offerKey, value);

                                    let rates = { ...$this.state.rates };
                                    $this.state.rates[index].validate = true;
                                    $this.setState({ rates: rates });
                                }}
                                label={
                                    value.notAvailable
                                        ? 'nicht mehr verfügbar'
                                        : value.validate
                                          ? 'prüfen'
                                          : 'jetzt prüfen'
                                }
                            />
                        </div>
                    </div>
                </>
            );
        }

        return (
            <div
                className={`rate-list ${
                    _.filter(rates, function (o) {
                        return o.validate;
                    }).length > 0
                        ? 'validate'
                        : ' '
                }`}>
                <div className="main head">
                    <h2 className="main-headline">Jetzt Datum und Uhrzeit auswählen</h2>

                    {unitInfo()}

                    {this.state.hasResult === false && (
                        <div className="unit-infos">
                            <div className="head">
                                <div className="icon alert">
                                    <span>!</span>
                                </div>
                                <div>
                                    Leider gibt es aktuell für diesen Ausflug keine Angebote.
                                    <br /> Bitte wählen Sie einen anderen Ausflug aus.
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="call-to-action flex">
                        {!unitInfo() && (
                            <Link
                                className="back-link"
                                to={{
                                    pathname: '/ausfluege/details/' + excursionCode,
                                }}>
                                zurück
                            </Link>
                        )}

                        {filterUnits()}

                        {sortTrigger()}

                        {rates.length > 0 && (
                            <div
                                className="filter-trigger"
                                onClick={() => this.setState({ showFilter: !this.state.showFilter })}>
                                <Icon name="filterList" ariaHidden /> Filter
                            </div>
                        )}
                    </div>
                </div>

                <div className="result-list">
                    {/* dummy data */}
                    {rates.length === 0 &&
                        this.state.hasResult !== false &&
                        Object.keys([0, 1, 2]).map((value, index) => (
                            <div key={index} className="card loading lazy-load-background">
                                <div className="head">
                                    <div className="heading"></div>
                                </div>
                                <div className="content">
                                    <div className="information">
                                        <div className="line">
                                            <div className="flex">
                                                <div>
                                                    <span className="icon"></span>
                                                </div>
                                                <div>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                            </div>
                                            <div>
                                                <span></span>
                                                <span></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="call-action">
                                        <span></span>
                                        <span></span>
                                        <span className="btn"></span>
                                    </div>
                                </div>
                            </div>
                        ))}

                    {/* result data  */}
                    {Object.keys(rates).map(
                        (value, index) =>
                            rates[value].show && (
                                <div
                                    className={`card ${rates[value].validate ? 'validate' : ''} ${
                                        rates[value]?.notAvailable ? 'not-available' : ''
                                    }`}
                                    key={index}>
                                    {card(rates[value], index)}
                                </div>
                            )
                    )}

                    {/* no result data  */}
                    {rates.length > 0 &&
                        _.filter(rates, function (o) {
                            return o.show;
                        }).length === 0 && (
                            <div className="nothingfound">
                                <h3 className="headline">Nichts gefunden!</h3>
                                <span className="youDo">
                                    Für diese Filterkriterien haben wir leider keine passenden Angebote.
                                    <br />
                                    Bitte ändern Sie Ihre Filtereinstellungen.
                                </span>
                            </div>
                        )}

                    {/* no result data */}
                    {this.state.hasResult === false && (
                        <Link to="/ausfluege">
                            <button className="button link">Zurück zur Übersicht</button>
                        </Link>
                    )}
                </div>
            </div>
        );
    }

    vacancy(k, $value) {
        let $this = this;

        if (k !== undefined) {
            let travellers = [];
            $this.state.searchParams.p.forEach((index) => {
                travellers[index] = storage.get('bookingData').bookingParams?.travellers[index];
            });

            const sendData = {
                requestType: 'vacancy',
                agent: 'atc',
                clientId: 'customerarea',
                travelType: 'excursion',
                vacancyType: 'excursion',
                excursionOfferKey: k,
                processToken: this.state.processToken,
            };

            axios(buildPostRequest(window.$requestUrl, '/vacancy', JSON.stringify(sendData)))
                .then((response) => response)
                .then((data) => {
                    let rates = { ...$this.state.rates };

                    let vacancyResult = data.data.data;
                    let { overallPackageVacancyResult } = data.data.data;

                    if (overallPackageVacancyResult === 'failed') {
                        $value.validate = false;
                        $value.valid = false;
                        $value.notAvailable = true;
                    }

                    if (overallPackageVacancyResult === 'ok') {
                        $value.validate = false;
                        $value.valid = true;

                        let bookStates = {
                            travelType: 'excursion',
                            vacancyToken: vacancyResult?.requestToken,
                            processToken: vacancyResult?.processToken,
                            vacancyData: vacancyResult?.excursionOffer,
                            bookingCategory: vacancyResult?.bookingCategory,
                            depositCategory: vacancyResult?.depositCategory,
                            cancellationCategory: vacancyResult?.cancellationCategory,
                            travellers: travellers,
                        };

                        // hasPriceChange : compare -> vacancy package price with offer package price
                        bookStates.hasPriceChange =
                            vacancyResult?.excursionOffer?.price?.packagePrice > $value?.price?.packagePrice;

                        sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                        let participants = new URLSearchParams(this.state.searchParams);

                        window.location.href = '#/buchung?p=' + participants.get('p');
                    } else {
                        $value.validate = false;
                        $value.valid = false;
                    }

                    $this.setState({ rates: rates });
                })
                .catch((error) => this.setState({ error }));
        }
    }

    render() {
        let { excursion } = this.state;
        if (excursion === undefined) {
            return false;
        }

        return (
            <div className={`page-excursion-rates ${this.state.showFilter ? 'filter-open' : ''}`}>
                <Header />

                <HeroTeaser size="full" />

                <main className="content-wrapper">
                    <TravelFactsFull />

                    <main className="content">
                        <div>
                            <div className="selected-excursion">
                                <div className="title">{excursion.title}</div>
                                <div className="cover-container">
                                    <LazyLoadImage
                                        src={excursion.images[0]?.replace(/original/gi, 'display')}
                                        alt={excursion.title + 'Bild '}
                                        effect="blur"
                                    />
                                </div>
                            </div>

                            {/* filterBar */}
                            {this.filterBar()}
                        </div>

                        {/* rates */}
                        {this.rates()}
                    </main>
                </main>

                <Footer />
            </div>
        );
    }
}

export default withRouter(ExcursionRates);
